export class ReservationStorageSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(data) {
        try {
            const info = JSON.parse(data);
            this.assertValid(info);
            return info;
        }
        catch (error) {
            return null;
        }
    }
    assertValid(data) {
        if (typeof data !== "object" ||
            data === null ||
            typeof data.fullName !== "string" ||
            typeof data.phone !== "string" ||
            typeof data.email !== "string" ||
            typeof data.numPeople !== "number" ||
            typeof data.info !== "string") {
            throw new Error("Invalid reservation data");
        }
    }
}
